var EventType = {
  Success: "Success",
  Info: "Info",
  Warning: "Warning",
  Error: "Error"
};
var AddMethod = {
  AddTop: "AddTop",
  AddOrReplaceTop: "AddOrReplaceTop"
};
var NotificationHandlerType = {
  None: "none"
};

export { AddMethod, EventType, NotificationHandlerType };
